import { Card, Descriptions, Table } from "antd";
import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { BreadCrumb } from "../../../components/main/LayoutComponents";
import { showNotificationWithIcon } from "../../../utils/helpers/helpers";
import { getUserInfo } from "../../../utils/redux/reducers/User";
import { Locale } from "../../../utils";
import { getUserItemsByBox } from "../qrcodes/qrcodeApi";
import breadCrumbDefault from "./breadCrumb";

const i18n = Locale.getInstance();

const VipUserItems = () => {
  const { userId } = useParams();
  const user = useSelector((state) => getUserInfo(state));

  const { data, error, isLoading } = useQuery(
    ["lottery-qrcode-user-items", userId, user.token],
    () =>
      getUserItemsByBox({
        user_id: parseInt(userId, 10),
        token: user.token,
      }),
    { enabled: !!userId }
  );

  if (error) {
    showNotificationWithIcon(error?.data?.message ?? error?.message, "error");
  }

  const tableData = data?.table ?? [];
  const statistics = data?.statistics ?? { total_boxes: 0, total_products: 0 };

  const columns = [
    {
      title: i18n.t("qrcode.name"),
      dataIndex: "qrcode_zh_name",
      key: "qrcode_zh_name",
      width: 200,
    },
    {
      title: i18n.t("qrcode.totalBoxes"),
      dataIndex: "total_boxes",
      key: "total_boxes",
      width: 100,
      align: "center",
    },
    {
      title: i18n.t("qrcode.totalProducts"),
      dataIndex: "total_products",
      key: "total_products",
      width: 120,
      align: "center",
    },
  ];

  const expandedRowRender = (row) => {
    const items = row.items ?? [];
    const innerColumns = [
      {
        title: i18n.t("qrcode.type"),
        key: "key",
        width: 100,
        render: (_, item) =>
          item.key === "box"
            ? (item.box?.type_label ?? i18n.t("qrcode.typeFilterBox"))
            : i18n.t("qrcode.otherProductGroup"),
      },
      {
        title: i18n.t("qrcode.itemCode"),
        key: "code",
        render: (_, item) => {
          if (item.key === "box" && item.box) {
            return item.box.code ?? item.box.secure_code ?? "—";
          }
          return "—";
        },
      },
      {
        title: i18n.t("qrcode.typeFilterProduct"),
        key: "products",
        render: (_, item) => {
          const products = item.products ?? [];
          if (products.length === 0) return "—";
          return products.map((p) => p.code ?? p.secure_code ?? p.id).join(", ");
        },
      },
    ];
    return (
      <Table
        columns={innerColumns}
        dataSource={items}
        rowKey={(r) => `${r.key}-${r.box?.id ?? "other"}`}
        pagination={false}
        size="small"
      />
    );
  };

  return (
    <>
      <BreadCrumb data={breadCrumbDefault} />
      <div className="qrcode vip-user-items">
        <Card title={i18n.t("qrcode.vipUserItems")} style={{ marginBottom: 16 }}>
          <Descriptions size="small" column={2}>
            <Descriptions.Item label={i18n.t("qrcode.totalBoxes")}>
              {statistics.total_boxes}
            </Descriptions.Item>
            <Descriptions.Item label={i18n.t("qrcode.totalProducts")}>
              {statistics.total_products}
            </Descriptions.Item>
          </Descriptions>
        </Card>
        <Table
          loading={isLoading}
          rowKey="qrcode_id"
          columns={columns}
          dataSource={tableData}
          expandable={{
            expandedRowRender,
            rowExpandable: (row) => (row.items?.length ?? 0) > 0,
          }}
          pagination={false}
        />
      </div>
    </>
  );
};

export default VipUserItems;
